export function adminTagsSearch(search: Record<string, unknown>) {
  return {
    q: typeof search.q === "string" ? search.q : "",
    status: search.status === "active" || search.status === "archived" ? search.status : "all",
    kind: search.kind === "builtin" || search.kind === "custom" ? search.kind : "all",
    access: search.access === "restricted" || search.access === "open" ? search.access : "all",
    sort: search.sort === "name" || search.sort === "name-desc" ? search.sort : "position",
    page:
      Number.isSafeInteger(Number(search.page)) && Number(search.page) > 0
        ? Number(search.page)
        : 1,
    size: search.size === 25 || search.size === 50 ? search.size : 10,
  };
}
